export default __webpack_public_path__ + "static/media/vscodium.75504cfa.webp";